module.exports = __webpack_public_path__ + "static/assets/a7ed0b73ed3cf2e24cf667ac05e6a978.png";